import { render, staticRenderFns } from "./ReadBarcode.vue?vue&type=template&id=3b57c674&scoped=true"
import script from "./ReadBarcode.vue?vue&type=script&lang=ts"
export * from "./ReadBarcode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b57c674",
  null
  
)

export default component.exports